<template>
  <div class="mobile-sidenav">
    <div class="d-flex justify-content-lg-start align-items-center close-icon">
      <div class="d-flex close-menu pointer" @click="$emit('close')">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="white" />
        </svg>
        <span class="pl-2 close-menu-text">
          Close
        </span>
      </div>
    </div>
    <div class="d-flex flex-column justify-content-center mt-4">
      <div v-if="permissions && !user.company_setup_step">
        <router-link class="menu-item-link"
                     to="/"
                     @click.native="$emit('clickLink')"
                     exact
        >
          <div class="menu-item">
            <div class="mod-icon mod-icon-dashboard" />
            <span class="menu-item-name pl-4">
              Dashboard
            </span>
          </div>
        </router-link>
        <router-link class="menu-item-link"
                     to="/schedule"
                     @click.native="$emit('clickLink')"
                     exact
        >
          <div class="menu-item">
            <div class="mod-icon mod-icon-schedule" style="width: 28px; height: 28px; margin-left: 2px" />
            <span class="menu-item-name pl-4">
              Schedule
            </span>
          </div>
        </router-link>
        <router-link class="menu-item-link"
                     v-if="$_can('leads.index') || $_can('leads.index-own')"
                     to="/leads"
                     @click.native="$emit('clickLink')"
                     exact
        >
          <div class="menu-item">
            <div class="mod-icon mod-icon-leads" />
            <span class="menu-item-name pl-4">
              Leads
            </span>
          </div>
        </router-link>
        <router-link class="menu-item-link"
                     v-if="$_can('jobs.index') || $_can('jobs.index-own')"
                     to="/jobs"
                     @click.native="$emit('clickLink')"
                     exact
        >
          <div class="menu-item">
            <div class="mod-icon mod-icon-jobs" />
            <span class="menu-item-name pl-4">
              Jobs
            </span>
          </div>
        </router-link>
        <router-link class="menu-item-link"
                     v-if="$_can('claims.index') || $_can('claims.index-own')"
                     to="/claims"
                     @click.native="$emit('clickLink')"
                     exact
        >
          <div class="menu-item">
            <div class="mod-icon mod-icon-claims" />
            <span class="menu-item-name pl-4">
              Claims
            </span>
          </div>
        </router-link>
        <span id="organizations">
          <a class="menu-item-link d-flex flex-column align-items-start"
             :class="[isOrganizationsActive || expanded.includes('organizations') ? 'router-link-active' : '']"
             @click="toggle('organizations')"
             data-toggle="collapse" data-target="#organization" aria-expanded="true"
             v-if="$_can('carriers.index')
               || $_can('companies.index')
               || $_can('clusters.users.index')
               || $_can('companies.customers.index')
               || $_can('carriers.movers.index')
               || $_can('carriers.trucks.index')"
             to="#"
          >
            <div class="menu-item">
              <div class="mod-icon mod-icon-main-users" />
              <span class="menu-item-name pl-4">
                Organization
              </span>
              <i class="fa fa-caret-down menu-caret" />
            </div>
            <hr class="link-divider" />
            <div id="organization"
                 class="collapse mt-3 w-100"
                 aria-labelledby="organization"
                 data-parent="#organizations"
                 :class="[isOrganizationsActive ? 'show' : '']"
            >
              <div class="submenu-wrapper">
                <router-link v-if="$_can('companies.index')"
                             @click.native="$emit('clickLink')"
                             class="menu-item-link submenu-item d-flex flex-column align-items-start"
                             to="/companies"
                >
                  <span class="l-sidebar-menu-title">Companies</span>
                </router-link>
                <router-link v-if="$_can('carriers.index')"
                             @click.native="$emit('clickLink')"
                             class="menu-item-link submenu-item d-flex flex-column align-items-start"
                             to="/carriers"
                >
                  <span class="l-sidebar-menu-title">Carriers</span>
                </router-link>
                <router-link v-if="$_can('clusters.users.index')"
                             @click.native="$emit('clickLink')"
                             class="menu-item-link submenu-item d-flex flex-column align-items-start"
                             to="/users"
                >
                  <span class="l-sidebar-menu-title">Users</span>
                </router-link>
                <router-link v-if="$_can('companies.customers.index')"
                             @click.native="$emit('clickLink')"
                             class="menu-item-link submenu-item d-flex flex-column align-items-start"
                             to="/customers"
                >
                  <span class="l-sidebar-menu-title">Customers</span>
                </router-link>
                <router-link v-if="$_can('carriers.movers.index')"
                             @click.native="$emit('clickLink')"
                             class="menu-item-link submenu-item d-flex flex-column align-items-start"
                             to="/movers"
                >
                  <span class="l-sidebar-menu-title">Movers</span>
                </router-link>
                <router-link v-if="$_can('carriers.trucks.index')"
                             @click.native="$emit('clickLink')"
                             class="menu-item-link submenu-item d-flex flex-column align-items-start"
                             to="/trucks"
                >
                  <span class="l-sidebar-menu-title">Trucks</span>
                </router-link>
              </div>
            </div>
          </a>
        </span>
        <span id="payments">
          <a
            class="menu-item-link d-flex flex-column align-items-start"
            :class="[isPaymentsActive || expanded.includes('payment') ? 'router-link-active' : '']"
            @click="toggle('payment')"
            data-toggle="collapse" data-target="#payment" aria-expanded="true"
            v-if="$_can('job-charges.index') || canAccessPayments"
            to="#"
          >
            <div class="menu-item">
              <div class="mod-icon mod-icon-payments" />
              <span class="menu-item-name pl-4">
                Payment
              </span>
              <i class="fa fa-caret-down menu-caret" />
            </div>
            <hr class="link-divider" />
            <div id="payment"
                 class="collapse mt-3 w-100"
                 aria-labelledby="organization"
                 data-parent="#payments"
                 :class="[isPaymentsActive ? 'show' : '']"
            >
              <div class="submenu-wrapper">
                <router-link v-if="$_can('job-charges.index')"
                             @click.native="$emit('clickLink')"
                             class="menu-item-link submenu-item d-flex flex-column align-items-start"
                             to="/transactions"
                >
                  <span class="l-sidebar-menu-title">Transactions</span>
                </router-link>
                <router-link v-if="canAccessPayments"
                             @click.native="$emit('clickLink')"
                             class="menu-item-link submenu-item d-flex flex-column align-items-start"
                             to="/settings/payment-gateways"
                >
                  <span class="l-sidebar-menu-title">Payment Gateways</span>
                </router-link>
              </div>
            </div>
          </a>
        </span>
        <span id="preferences">
          <a
            class="menu-item-link d-flex flex-column align-items-start"
            :class="[isSettingsActive || isSettingsOpen ? 'router-link-active' : '']"
            @click="toggle('settings-top-level')"
            data-toggle="collapse" data-target="#settings" aria-expanded="true"
            v-if="$_can('leads.follow-up-email-templates.index')
              || $_can('phone-numbers.index')
              || $_can('leads.follow-ups.index')
              || $_can('carriers.roles.index')
              || $_can('companies.domains.index')
              || $_can('companies.configurations.index')"
            to="#"
          >
            <div class="menu-item">
              <div class="mod-icon mod-icon-settings" />
              <span class="menu-item-name pl-4">
                Preferences
              </span>
              <i class="fa fa-caret-down menu-caret" />
            </div>
            <hr class="link-divider" />
          </a>
          <div id="settings"
               class="collapse  w-100"
               :class="[isSettingsActive ? 'show' : '']"
               aria-labelledby="organization"
               data-parent="#preferences"
          >
            <div class="submenu-wrapper"
                 :class="[isSettingsActive || isSettingsOpen ? 'router-link-active' : '']"
            >
              <span id="domains">
                <a v-if="$_can('companies.domains.index')"
                   class="menu-item-link submenu-item-tier3 d-flex flex-column align-items-start"
                   @click="toggle('mailing')"
                   data-toggle="collapse" data-target="#mailing" aria-expanded="true"
                   to="#"
                >
                  <span class="l-sidebar-menu-title">Mailing</span>
                  <i class="fa fa-caret-down submenu-caret" />
                  <div id="mailing"
                       class="collapse mt-3 w-100"
                       aria-labelledby="mailing"
                       data-parent="#domains"
                  >
                    <!--                    <router-link v-if="$_can('companies.domains.index')"-->
                    <!--                                 @click.native="$emit('clickLink')"-->
                    <!--                                 class="menu-item-link submenu-item d-flex flex-column align-items-start"-->
                    <!--                                 to="/settings/domains"-->
                    <!--                    >-->
                    <!--                      <span class="l-sidebar-menu-title">Company Domains</span>-->
                    <!--                    </router-link>-->
                    <router-link
                      @click.native="$emit('clickLink')"
                      class="menu-item-link submenu-item d-flex flex-column align-items-start"
                      to="/settings/smtp-servers"
                    >
                      <span class="l-sidebar-menu-title">SMTP servers</span>
                    </router-link>
                    <router-link v-if="$_can('leads.follow-up-email-templates.index')"
                                 @click.native="$emit('clickLink')"
                                 class="menu-item-link submenu-item d-flex flex-column align-items-start"
                                 to="/settings/follow-up-templates"
                    >
                      <span class="l-sidebar-menu-title">Follow up templates</span>
                    </router-link>
                    <router-link v-if="$_can('claims.email-templates.index')"
                                 @click.native="$emit('clickLink')"
                                 class="menu-item-link submenu-item d-flex flex-column align-items-start"
                                 to="/settings/claim-templates"
                    >
                      <span class="l-sidebar-menu-title">Claim emails</span>
                    </router-link>
                    <router-link v-if="$_can('claims.acknowledgement-email-templates.index')"
                                 @click.native="$emit('clickLink')"
                                 class="menu-item-link submenu-item d-flex flex-column align-items-start"
                                 to="/settings/acknowledgement-templates"
                    >
                      <span class="l-sidebar-menu-title">Acknowledgement emails</span>
                    </router-link>
                    <router-link v-if="$_can('claims.settlement-email-templates.index')"
                                 @click.native="$emit('clickLink')"
                                 class="menu-item-link submenu-item d-flex flex-column align-items-start"
                                 to="/settings/settlement-templates"
                    >
                      <span class="l-sidebar-menu-title">Settlement emails</span>
                    </router-link>
                  </div>
                </a>
              </span>
              <router-link v-if="$_can('carriers.roles.index')"
                           @click.native="$emit('clickLink')"
                           class="menu-item-link submenu-item-tier3 d-flex flex-column align-items-start"
                           to="/settings/user-roles"
              >
                <span class="l-sidebar-menu-title">User roles</span>
              </router-link>
              <router-link v-if="$_can('phone-numbers.index')"
                           @click.native="$emit('clickLink')"
                           class="menu-item-link submenu-item-tier3 d-flex flex-column align-items-start"
                           to="/settings/phone-numbers"
              >
                <span class="l-sidebar-menu-title">Phone numbers</span>
              </router-link>
              <span id="messages">
                <a class="menu-item-link submenu-item-tier3 d-flex flex-column align-items-start"
                   @click="toggle('messages')"
                   data-toggle="collapse" data-target="#message" aria-expanded="true"
                   to="#"
                >
                  <span class="l-sidebar-menu-title">Messages</span>
                  <i class="fa fa-caret-down submenu-caret" />
                  <div id="message"
                       class="collapse mt-3 w-100"
                       aria-labelledby="messages"
                       data-parent="#messages"
                  >
                    <router-link v-if="$_can('settings.messages.index-all') || $_can('settings.messages.index-own')"
                                 @click.native="$emit('clickLink')"
                                 class="menu-item-link submenu-item d-flex flex-column align-items-start"
                                 to="/settings/messages"
                    >
                      <span class="l-sidebar-menu-title">Customer Messages</span>
                    </router-link>
                    <router-link v-if="$_can('carriers.movers.get-text-message-threads')"
                                 @click.native="$emit('clickLink')"
                                 class="menu-item-link submenu-item d-flex flex-column align-items-start"
                                 to="/settings/mover-messages"
                    >
                      <span class="l-sidebar-menu-title">Mover Messages</span>
                    </router-link>
                  </div>
                </a>
              </span>
              <router-link v-if="$_can('companies.configurations.index')"
                           @click.native="$emit('clickLink')"
                           class="menu-item-link submenu-item-tier3 d-flex flex-column align-items-start"
                           to="/rates"
              >
                <span class="l-sidebar-menu-title">Rates</span>
              </router-link>
              <router-link v-if="$_can('claims.types.index')"
                           @click.native="$emit('clickLink')"
                           class="menu-item-link submenu-item-tier3 d-flex flex-column align-items-start"
                           to="/settings/claim-types"
              >
                <span class="l-sidebar-menu-title">Claim types</span>
              </router-link>
              <router-link @click.native="$emit('clickLink')"
                           class="menu-item-link submenu-item-tier3 d-flex flex-column align-items-start"
                           to="/contracts"
              >
                <span class="l-sidebar-menu-title">Contracts</span>
              </router-link>
              <router-link @click.native="$emit('clickLink')"
                           class="menu-item-link submenu-item-tier3 d-flex flex-column align-items-start"
                           to="/settings/filters"
              >
                <span class="l-sidebar-menu-title">Filters</span>
              </router-link>
              <router-link v-if="$_can('tags.show')"
                           @click.native="$emit('clickLink')"
                           class="menu-item-link submenu-item-tier3 d-flex flex-column align-items-start"
                           to="/settings/tags"
              >
                <span class="l-sidebar-menu-title">Tags</span>
              </router-link>
            </div>
          </div>
        </span>
        <span id="statistics">
          <a
            class="menu-item-link d-flex flex-column align-items-start"
            :class="[isStatisticsActive || expanded.includes('statistics') ? 'router-link-active' : '']"
            @click="toggle('statistics')"
            data-toggle="collapse" data-target="#statistic" aria-expanded="true"
            v-if="$_can('clusters.totals.index')"
            to="#"
          >
            <div class="menu-item">
              <div class="mod-icon mod-icon-reports" />
              <span class="menu-item-name pl-4">
                Statistics
              </span>
              <i class="fa fa-caret-down menu-caret" />
            </div>
            <hr class="link-divider" />
            <div id="statistic"
                 class="collapse mt-3 w-100"
                 aria-labelledby="statistic"
                 data-parent="#statistics"
                 :class="[isStatisticsActive ? 'show' : '']"
            >
              <div class="submenu-wrapper">
                <router-link v-if="$_can('clusters.totals.index')"
                             @click.native="$emit('clickLink')"
                             class="menu-item-link submenu-item d-flex flex-column align-items-start"
                             to="/reports/totals"
                >
                  <span class="l-sidebar-menu-title">Totals</span>
                </router-link>
                <router-link v-if="$_can('movers.wages.index')"
                             @click.native="$emit('clickLink')"
                             class="menu-item-link submenu-item d-flex flex-column align-items-start"
                             to="/reports/mover-totals"
                >
                  <span class="l-sidebar-menu-title">Mover Totals</span>
                </router-link>
                <router-link v-if="$_can('sales.view-totals')"
                             @click.native="$emit('clickLink')"
                             class="menu-item-link submenu-item d-flex flex-column align-items-start"
                             to="/reports/sales"
                >
                  <span class="l-sidebar-menu-title">Sales Totals</span>
                </router-link>
                <router-link v-if="$_can('job-discounts.index')"
                             @click.native="$emit('clickLink')"
                             class="menu-item-link submenu-item d-flex flex-column align-items-start"
                             to="/reports/discounts"
                >
                  <span class="l-sidebar-menu-title">Discounts</span>
                </router-link>
                <router-link v-if="$_can('companies.payment-profiles.index')"
                             @click.native="$emit('clickLink')"
                             class="menu-item-link submenu-item d-flex flex-column align-items-start"
                             to="/reports/ratings"
                >
                  <span class="l-sidebar-menu-title">Ratings</span>
                </router-link>
              </div>
            </div>
          </a>
        </span>
      </div>
      <div>
        <a href="https://docs.mod24.com/mod24/" class="menu-item-link" target="_blank">
          <div class="menu-item">
            <div class="mod-icon mod-icon-help" />
            <span class="menu-item-name pl-4">
              Help
            </span>
          </div>
        </a>
      </div>
      <div class="d-flex justify-content-lg-start align-items-center logout-wrapper logout-icon">
        <div class="d-flex close-menu pointer" @click="$emit('logout')">
          <svg width="28" height="28" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 4.24702V17.0207C0 18.1968 0.490041 19.2423 1.27411 20.059C2.05817 20.8431 3.07092 21.2678 4.24702 21.2678H10.6502V18.6215H4.24702C3.36494 18.6215 2.67889 17.9028 2.67889 17.0207V4.24702C2.67889 3.36495 3.36494 2.67889 4.24702 2.67889H10.6502V0H4.24702C3.07092 0 2.05817 0.457371 1.27411 1.24144C0.490041 2.05817 0 3.07092 0 4.24702ZM7.02391 8.102V13.1984C7.02391 13.7865 7.54662 14.2765 8.13467 14.2765H14.0478V18.2948C14.0478 18.6542 14.2438 18.9482 14.5705 19.1116C14.7012 19.1443 14.8319 19.1443 14.8972 19.1443C15.1259 19.1443 15.3219 19.0789 15.4853 18.9156L23.1626 11.2383C23.5219 10.9442 23.4893 10.3562 23.1626 10.0295L15.4853 2.38486C15.0279 1.89482 14.0478 2.18885 14.0478 2.97291V7.02392H8.13467C7.54662 7.02392 7.02391 7.51396 7.02391 8.102Z" fill="white" />
          </svg>
          <span class="pl-4 close-menu-text">
            Logout
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    expanded: [],
  }),
  computed: {
    isOrganizationsActive() {
      return (
        this.$route.path === '/carriers' ||
        this.$route.path === '/companies' ||
        this.$route.path === '/users' ||
        this.$route.path === '/customers' ||
        this.$route.path === '/movers' ||
        this.$route.path === '/trucks'
      );
    },
    isPaymentsActive() {
      return (
        this.$route.path === '/settings/payment-gateways' || this.$route.path === '/transactions'
      );
    },
    isSettingsActive() {
      return (
        this.$route.path === '/settings/domains' ||
        this.$route.path === '/settings/follow-up-templates' ||
        this.$route.path === '/settings/claim-templates' ||
        this.$route.path === '/settings/acknowledgement-templates' ||
        this.$route.path === '/settings/settlement-templates' ||
        this.$route.path === '/settings/user-roles' ||
        this.$route.path === '/settings/phone-numbers' ||
        this.$route.path === '/settings/messages' ||
        this.$route.path === '/mover-messages' ||
        this.$route.path === '/rates' ||
        this.$route.path === '/settings/claim-types' ||
        this.$route.path === '/contracts'
      );
    },
    isSettingsOpen() {
      return (
        this.expanded.includes('settings-top-level') ||
        this.expanded.includes('mailing') ||
        this.expanded.includes('messages')
      );
    },
    isStatisticsActive() {
      return this.$route.path === '/reports/totals' || this.$route.path === '/reports/ratings';
    },
    canAccessPayments() {
      return this.user.roles.some(role => role.id === 1 || role.id === 35);
    },
  },
  methods: {
    toggle(item) {
      if (this.expanded.includes(item)) {
        const index = this.expanded.indexOf(item);
        if (index > -1) {
          this.expanded.splice(index, 1);
        }
      } else {
        this.expanded.push(item);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  color: #fff;
}
.router-link-active {
  color: #fff;
  background-color: #224ecc;
}
.close-icon {
  padding: 25px 0 0 20px;
}
.logout-icon {
  padding: 30px;
}
.close-menu-text {
  font-size: 18px;
  color: #ffffff;
}
.menu-item-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 4px 4px 4px 25px;
}
.menu-item-link:hover {
  color: #fff;
}
.menu-item {
  min-height: 70px;
  display: flex;
  align-items: center;
}
.menu-item-name {
  font-size: 19px;
  color: #fff;
}
.link-divider {
  width: 100%;
  margin-top: 0;
  margin-bottom: -5px;
  opacity: 0.2;
  border: 1px dashed #ffffff;
  margin-left: -15px;
}
.menu-caret {
  position: absolute;
  right: 10%;
  color: #fff;
}
.submenu-caret {
  position: absolute;
  right: 10%;
}
.submenu-wrapper {
  padding-left: 60px;
  color: #fff;
}
.submenu-item {
  padding: 17px 25px 25px 25px;
}
.submenu-item-tier3 {
  padding: 18px 25px 25px 45px;
}
.logout-wrapper {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/MobileSidenav.vue